import React from 'react';
import { RiskFreeSVG } from './SVGs/WhySectionSVGs';

const StartFree = () => {
  return (
    <section id="start-free" className="start-free">
      <div className="container">
        <div className="start-free-box">
          <div className="start-free-grid">
            <div className="start-free-content">
              <span className="label">start risk-free</span>
              <h2>Build Trust Before You Commit</h2>
              <p>
                Your first sample (up to €50) is completely free. Your first carbon emission report is free.
                No obligation — just transparency.
              </p>
              <ul>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span><strong>Free First Sample (Up to €50)</strong> — Evaluate machining quality, tolerances, material selection, finish, packaging, and documentation standards.</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span><strong>Free Carbon Emission Report</strong> — Visibility into environmental footprint of production and logistics. Supports ESG and CSRD alignment.</span>
                </li>
              </ul>
              <div className="actions">
                <button className="btn-eu">Request Free Sample</button>
                <button className="btn-outline">Submit RFQ</button>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
              <div style={{ width: '200px' }}>
                <RiskFreeSVG />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartFree;